export enum QuoteState {
  All = '',
  Open = 'open',
  Closed = 'closed',
}
